import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את המעגל (בלי להאשים)",
    opening: localizedGenderNode(
      [
      "היום אני לא שופט. אני מזהה את הדפוס: רדיפה–בריחה."
    ],
      [
      "היום אני לא שופט. אני מזהה את הדפוס: רדיפה–בריחה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “זה דפוס. לא אני ‘מקולקל’.”",
      "מיינדפולנס קצר:",
      "אני שם לב: האם אני כרגע נצמד/ת או מתרחק/ת?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “זה דפוס. לא אני ‘מקולקל’.”",
      "מיינדפולנס קצר:",
      "אני שם לב: האם אני כרגע נצמד/ת או מתרחק/ת?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "באיזה רגעים אני נהיה/ת “הרודף/ת”? ובאיזה רגעים אני נהיה/ת “הנמנע/ת”?\n[כאן אני כותב]",
      "מה הטריגר הכי שכיח שמדליק את המעגל אצלנו?\n[כאן אני כותב]",
      "מה אני עושה מיד כשהדפוס נדלק? (טלפון/טון/שתיקה/האשמה)\n[כאן אני כותב]"
    ],
      [
      "באיזה רגעים אני נהיה/ת “הרודף/ת”? ובאיזה רגעים אני נהיה/ת “הנמנע/ת”?\n[כאן אני כותב]",
      "מה הטריגר הכי שכיח שמדליק את המעגל אצלנו?\n[כאן אני כותב]",
      "מה אני עושה מיד כשהדפוס נדלק? (טלפון/טון/שתיקה/האשמה)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני מזהה את המעגל. זיהוי הוא התחלה של חופש."
    ],
      [
      "סגירה",
      "היום אני מזהה את המעגל. זיהוי הוא התחלה של חופש."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום כשזה מתחיל — אני עושה “עצירת 20 שניות”: נשימה + להגיד בלב “זה המעגל”.",
      "פעם אחת היום כשזה מתחיל — אני עושה “עצירת 20 שניות”: נשימה + להגיד בלב “זה המעגל”."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה הרדיפה באמת מחפשת",
    opening: localizedGenderNode(
      [
      "היום אני מגלה: הרדיפה מחפשת ביטחון, לא ניצחון."
    ],
      [
      "היום אני מגלה: הרדיפה מחפשת ביטחון, לא ניצחון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני מחפש/ת קרבה, לא מלחמה.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: מה הצורך שלי עכשיו — מתחת לדחף?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני מחפש/ת קרבה, לא מלחמה.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: מה הצורך שלי עכשיו — מתחת לדחף?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כשאני “רודף/ת” — מה אני מנסה להשיג? (שקט/אישור/תגובה/אהבה)\n[כאן אני כותב]",
      "מה הדבר שהכי מפחיד אותי אם אין תגובה?\n[כאן אני כותב]",
      "איזה משפט אחד נקי הייתי רוצה להגיד במקום להציף?\n[כאן אני כותב]"
    ],
      [
      "כשאני “רודף/ת” — מה אני מנסה להשיג? (שקט/אישור/תגובה/אהבה)\n[כאן אני כותב]",
      "מה הדבר שהכי מפחיד אותי אם אין תגובה?\n[כאן אני כותב]",
      "איזה משפט אחד נקי הייתי רוצה להגיד במקום להציף?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשהצורך ברור — הטון נרגע."
    ],
      [
      "סגירה",
      "כשהצורך ברור — הטון נרגע."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת משפט נקי אחד: “אני בוחר/ת/ה __ עכשיו” (בלי האשמה).",
      "אני כותב/ת משפט נקי אחד: “אני בוחר/ת/ה __ עכשיו” (בלי האשמה)."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה ההימנעות באמת מנסה להגן",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה: ההימנעות היא הגנה, לא רוע."
    ],
      [
      "היום אני מבין/ה: ההימנעות היא הגנה, לא רוע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “המרחק שלי מנסה לשמור עליי.”",
      "מיינדפולנס קצר:",
      "אני שם לב: האם הגוף שלי נכנס ל”כיבוי”?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “המרחק שלי מנסה לשמור עליי.”",
      "מיינדפולנס קצר:",
      "אני שם לב: האם הגוף שלי נכנס ל”כיבוי”?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כשאני “בורח/ת” — ממה אני מנסה להגן על עצמי? (ביקורת/הצפה/כישלון/שליטה)\n[כאן אני כותב]",
      "איך הגוף שלי מרגיש ברגע שאני מתרחק/ת?\n[כאן אני כותב]",
      "מה הייתי בוחר/ת/ה לשמוע כדי להישאר עוד דקה?\n[כאן אני כותב]"
    ],
      [
      "כשאני “בורח/ת” — ממה אני מנסה להגן על עצמי? (ביקורת/הצפה/כישלון/שליטה)\n[כאן אני כותב]",
      "איך הגוף שלי מרגיש ברגע שאני מתרחק/ת?\n[כאן אני כותב]",
      "מה הייתי בוחר/ת/ה לשמוע כדי להישאר עוד דקה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הימנעות לא אומרת “לא אכפת לי”. לפעמים היא אומרת “יותר מדי”."
    ],
      [
      "סגירה",
      "הימנעות לא אומרת “לא אכפת לי”. לפעמים היא אומרת “יותר מדי”."
    ]
    ),
    action: localizedGenderNode(
      "כשאני רוצה להיעלם — אני אומר/ת משפט קצר: “אני מוצף/ת. אני בוחר/ת/ה 10 דקות.”",
      "כשאני רוצה להיעלם — אני אומר/ת משפט קצר: “אני מוצף/ת. אני בוחר/ת/ה 10 דקות.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "טריגרים: מה בדיוק מדליק אותנו",
    opening: localizedGenderNode(
      [
      "היום אני ממפה את הנקודות שמדליקות את המעגל."
    ],
      [
      "היום אני ממפה את הנקודות שמדליקות את המעגל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אם אני מזהה טריגר — אני פחות נגרר.”",
      "מיינדפולנס קצר:",
      "אני שם לב: מה הפעימה הראשונה בגוף לפני תגובה?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אם אני מזהה טריגר — אני פחות נגרר.”",
      "מיינדפולנס קצר:",
      "אני שם לב: מה הפעימה הראשונה בגוף לפני תגובה?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "3 טריגרים עיקריים שמדליקים אצלנו רדיפה–בריחה:\n[כאן אני כותב]",
      "איזה טריגר קשור לפחד נטישה?\n[כאן אני כותב]",
      "איזה טריגר קשור לפחד להיבלע/לאבד עצמי?\n[כאן אני כותב]"
    ],
      [
      "3 טריגרים עיקריים שמדליקים אצלנו רדיפה–בריחה:\n[כאן אני כותב]",
      "איזה טריגר קשור לפחד נטישה?\n[כאן אני כותב]",
      "איזה טריגר קשור לפחד להיבלע/לאבד עצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "טריגר הוא סימן אזהרה — לא גזר דין."
    ],
      [
      "סגירה",
      "טריגר הוא סימן אזהרה — לא גזר דין."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת טריגר אחד ומצמיד/ה לו משפט עוגן: “עצור/י. זה טריגר.”",
      "אני בוחר/ת טריגר אחד ומצמיד/ה לו משפט עוגן: “עצור/י. זה טריגר.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "שפת גוף במקום מלחמה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לגוף כדי לא להבעיר."
    ],
      [
      "היום אני חוזר/ת לגוף כדי לא להבעיר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "3 נשימות איטיות.",
      "מיינדפולנס קצר:",
      "אני משחרר/ת כתפיים, מרכך/ת לסת, מרפה/ת בטן."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "3 נשימות איטיות.",
      "מיינדפולנס קצר:",
      "אני משחרר/ת כתפיים, מרכך/ת לסת, מרפה/ת בטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הגוף שלי ננעל בזמן קונפליקט?\n[כאן אני כותב]",
      "מה עוזר לי להוריד 10% מתח? (הליכה/מים/מוזיקה/מקלחת)\n[כאן אני כותב]",
      "איזה סימן מוקדם בגוף אומר לי “אני בדרך להתפוצץ/להיעלם”?\n[כאן אני כותב]"
    ],
      [
      "איפה הגוף שלי ננעל בזמן קונפליקט?\n[כאן אני כותב]",
      "מה עוזר לי להוריד 10% מתח? (הליכה/מים/מוזיקה/מקלחת)\n[כאן אני כותב]",
      "איזה סימן מוקדם בגוף אומר לי “אני בדרך להתפוצץ/להיעלם”?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשאני מרגיע/ה גוף — אני מציל/ה קשר."
    ],
      [
      "סגירה",
      "כשאני מרגיע/ה גוף — אני מציל/ה קשר."
    ]
    ),
    action: localizedGenderNode(
      "בזמן טריגר: מים + נשימה אחת לפני מילים.",
      "בזמן טריגר: מים + נשימה אחת לפני מילים."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "“בקשה” במקום “תביעה”",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להמיר לחץ לבקשה."
    ],
      [
      "היום אני מתרגל/ת להמיר לחץ לבקשה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בקשה מקרבת. תביעה מרחיקה.”",
      "מיינדפולנס קצר:",
      "אני בודק/ת: אני בא/ה עכשיו כדי לקבל, או כדי לתקן?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בקשה מקרבת. תביעה מרחיקה.”",
      "מיינדפולנס קצר:",
      "אני בודק/ת: אני בא/ה עכשיו כדי לקבל, או כדי לתקן?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה התביעה שאני מוציא/ה בדרך כלל?\n[כאן אני כותב]",
      "איך היא נשמעת כבקשה קצרה ונקייה?\n[כאן אני כותב]",
      "מה אני מוכן/ה לקבל גם אם התשובה לא מושלמת?\n[כאן אני כותב]"
    ],
      [
      "מה התביעה שאני מוציא/ה בדרך כלל?\n[כאן אני כותב]",
      "איך היא נשמעת כבקשה קצרה ונקייה?\n[כאן אני כותב]",
      "מה אני מוכן/ה לקבל גם אם התשובה לא מושלמת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בקשה טובה יוצרת מקום לתגובה."
    ],
      [
      "סגירה",
      "בקשה טובה יוצרת מקום לתגובה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת “בקשת זהב” אחת: קצרה, ספציפית, בלי עבר.",
      "אני כותב/ת “בקשת זהב” אחת: קצרה, ספציפית, בלי עבר."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "“מרחב בטוח” לשיחה (10 דקות)",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת לדבר בלי להפעיל את המעגל."
    ],
      [
      "היום אני לומד/ת לדבר בלי להפעיל את המעגל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני רוצה חיבור, לא ניצחון.”",
      "מיינדפולנס קצר:",
      "אני מכוון/ת טון: שקט, איטי, משפטים קצרים."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני רוצה חיבור, לא ניצחון.”",
      "מיינדפולנס קצר:",
      "אני מכוון/ת טון: שקט, איטי, משפטים קצרים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה נושא אחד שאני רוצה לדבר עליו בלי להציף?\n[כאן אני כותב]",
      "מה המשפט הפותח הכי נקי שאני יכול/ה להגיד?\n[כאן אני כותב]",
      "מה גבול הזמן שמתאים לי לשיחה כדי לא להישאב?\n[כאן אני כותב]"
    ],
      [
      "מה נושא אחד שאני רוצה לדבר עליו בלי להציף?\n[כאן אני כותב]",
      "מה המשפט הפותח הכי נקי שאני יכול/ה להגיד?\n[כאן אני כותב]",
      "מה גבול הזמן שמתאים לי לשיחה כדי לא להישאב?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שיחה קצרה ונקייה עדיפה על לילה שלם של מעגל."
    ],
      [
      "סגירה",
      "שיחה קצרה ונקייה עדיפה על לילה שלם של מעגל."
    ]
    ),
    action: localizedGenderNode(
      "אם יש שיחה: “10 דקות בלבד” + עצירה באמצע לנשימה.",
      "אם יש שיחה: “10 דקות בלבד” + עצירה באמצע לנשימה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "תיקון אחרי טריגר (Repair)",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת לתקן מהר — במקום להיענש ימים."
    ],
      [
      "היום אני לומד/ת לתקן מהר — במקום להיענש ימים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אפשר לתקן, גם אם היה מכוער.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: מה החלק שלי בדפוס הזה — בלי שיימינג?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אפשר לתקן, גם אם היה מכוער.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: מה החלק שלי בדפוס הזה — בלי שיימינג?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עשיתי שהדליק?\n[כאן אני כותב]",
      "מה הייתי עושה אחרת ב-10% פחות עוצמה?\n[כאן אני כותב]",
      "איזה משפט תיקון קצר מתאים לי? (“אני מצטער/ת על הטון…”)\n[כאן אני כותב]"
    ],
      [
      "מה עשיתי שהדליק?\n[כאן אני כותב]",
      "מה הייתי עושה אחרת ב-10% פחות עוצמה?\n[כאן אני כותב]",
      "איזה משפט תיקון קצר מתאים לי? (“אני מצטער/ת על הטון…”)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "תיקון הוא כוח. לא חולשה."
    ],
      [
      "סגירה",
      "תיקון הוא כוח. לא חולשה."
    ]
    ),
    action: localizedGenderNode(
      "אני מנסח/ת משפט תיקון אחד ושומר/ת אותו מוכן.",
      "אני מנסח/ת משפט תיקון אחד ושומר/ת אותו מוכן."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "לייצר “פסק זמן” נכון",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל/ה בין פסק זמן לבין נטישה."
    ],
      [
      "היום אני מבדיל/ה בין פסק זמן לבין נטישה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פסק זמן הוא גשר, לא בריחה.”",
      "מיינדפולנס קצר:",
      "אני שם לב: האם אני מבקש/ת מרחב עם כבוד?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פסק זמן הוא גשר, לא בריחה.”",
      "מיינדפולנס קצר:",
      "אני שם לב: האם אני מבקש/ת מרחב עם כבוד?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני בוחר/ת/ה פסק זמן כדי לא להתפוצץ/להיעלם?\n[כאן אני כותב]",
      "איך אני אומר/ת פסק זמן בלי לאיים? (משפט אחד)\n[כאן אני כותב]",
      "מה אני מתרוצה/ת: לחזור מתי? (זמן ברור)\n[כאן אני כותב]"
    ],
      [
      "מתי אני בוחר/ת/ה פסק זמן כדי לא להתפוצץ/להיעלם?\n[כאן אני כותב]",
      "איך אני אומר/ת פסק זמן בלי לאיים? (משפט אחד)\n[כאן אני כותב]",
      "מה אני מתרוצה/ת: לחזור מתי? (זמן ברור)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מרחב עם זמן חזרה = ביטחון."
    ],
      [
      "סגירה",
      "מרחב עם זמן חזרה = ביטחון."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת “נוסחת פסק זמן”: “אני בוחר/ת/ה 20 דקות, חוזר/ת ב-__.”",
      "אני כותב/ת “נוסחת פסק זמן”: “אני בוחר/ת/ה 20 דקות, חוזר/ת ב-__.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "פחדים מתחת למעגל",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחדים שמפעילים אותנו."
    ],
      [
      "היום אני נוגע/ת בפחדים שמפעילים אותנו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פחדים רוצים חיבוק, לא מלחמה.”",
      "מיינדפולנס קצר:",
      "אני שם לב: איזה פחד עיקרי עולה — נטישה או בליעה?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פחדים רוצים חיבוק, לא מלחמה.”",
      "מיינדפולנס קצר:",
      "אני שם לב: איזה פחד עיקרי עולה — נטישה או בליעה?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "הפחד המרכזי שלי בקשר הוא: __\n[כאן אני כותב]",
      "מה אני עושה כשאני מפחד/ת? (רודף/בורח/מבקר/שותק)\n[כאן אני כותב]",
      "איזה אמת עדינה אני יכול/ה להגיד לעצמי כשהפחד עולה?\n[כאן אני כותב]"
    ],
      [
      "הפחד המרכזי שלי בקשר הוא: __\n[כאן אני כותב]",
      "מה אני עושה כשאני מפחד/ת? (רודף/בורח/מבקר/שותק)\n[כאן אני כותב]",
      "איזה אמת עדינה אני יכול/ה להגיד לעצמי כשהפחד עולה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשאני רואה פחד — אני פחות הופך אותו להתקפה."
    ],
      [
      "סגירה",
      "כשאני רואה פחד — אני פחות הופך אותו להתקפה."
    ]
    ),
    action: localizedGenderNode(
      "משפט עוגן: “זה פחד. הוא לא רוצה להוביל פעולה.”",
      "משפט עוגן: “זה פחד. הוא לא רוצה להוביל פעולה.”"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "גבולות וצרכים (בלי מלחמה)",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת צורך וגבול נקיים."
    ],
      [
      "היום אני מנסח/ת צורך וגבול נקיים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני יכול/ה להיות ברור/ה ועדין/ה.”",
      "מיינדפולנס קצר:",
      "אני בודק/ת: מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני יכול/ה להיות ברור/ה ועדין/ה.”",
      "מיינדפולנס קצר:",
      "אני בודק/ת: מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "צורך אחד שלי בקשר שאני נוטה להסתיר:\n[כאן אני כותב]",
      "גבול אחד שאני בוחר/ת/ה כדי לא להישחק:\n[כאן אני כותב]",
      "איך אני אומר/ת את זה בגוף ראשון, בלי “את/ה תמיד”?\n[כאן אני כותב]"
    ],
      [
      "צורך אחד שלי בקשר שאני נוטה להסתיר:\n[כאן אני כותב]",
      "גבול אחד שאני בוחר/ת/ה כדי לא להישחק:\n[כאן אני כותב]",
      "איך אני אומר/ת את זה בגוף ראשון, בלי “את/ה תמיד”?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול הוא שמירה, לא עונש."
    ],
      [
      "סגירה",
      "גבול הוא שמירה, לא עונש."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת משפט גבול אחד קצר, נקי.",
      "אני כותב/ת משפט גבול אחד קצר, נקי."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "מה נכון לי בקשר הזה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת התאמה, לא רק פחד."
    ],
      [
      "היום אני בודק/ת התאמה, לא רק פחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא רק מגיב/ה. אני בוחר/ת.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: האם אני מרגיש/ה יותר אני או פחות אני?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא רק מגיב/ה. אני בוחר/ת.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: האם אני מרגיש/ה יותר אני או פחות אני?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עובד בקשר הזה באמת?\n[כאן אני כותב]",
      "מה לא עובד — שוב ושוב?\n[כאן אני כותב]",
      "מה אני בוחר/ת/ה כדי שהמעגל יירגע לאורך זמן?\n[כאן אני כותב]"
    ],
      [
      "מה עובד בקשר הזה באמת?\n[כאן אני כותב]",
      "מה לא עובד — שוב ושוב?\n[כאן אני כותב]",
      "מה אני בוחר/ת/ה כדי שהמעגל יירגע לאורך זמן?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "להכיר אמת זה לא לפרק — זה להאיר."
    ],
      [
      "סגירה",
      "להכיר אמת זה לא לפרק — זה להאיר."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת 1 שינוי קטן שאני מבקש/ת בצורה נקייה.",
      "אני כותב/ת 1 שינוי קטן שאני מבקש/ת בצורה נקייה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "“חוזה קטן” נגד המעגל",
    opening: localizedGenderNode(
      [
      "היום אני בונה תכנית קטנה שמחליפה דפוס."
    ],
      [
      "היום אני בונה תכנית קטנה שמחליפה דפוס."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “עקביות עדיפה על דרמה.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: מה פעולה קטנה יכולה לשבור את האוטומט?"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “עקביות עדיפה על דרמה.”",
      "מיינדפולנס קצר:",
      "אני שואל/ת: מה פעולה קטנה יכולה לשבור את האוטומט?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הטריגר #1 שלנו?\n[כאן אני כותב]",
      "מה “הצעד הראשון” החדש במקום רדיפה/בריחה?\n[כאן אני כותב]",
      "מה המשפט המוסכם שאני אומר/ת לעצמי כשזה נדלק?\n[כאן אני כותב]"
    ],
      [
      "מה הטריגר #1 שלנו?\n[כאן אני כותב]",
      "מה “הצעד הראשון” החדש במקום רדיפה/בריחה?\n[כאן אני כותב]",
      "מה המשפט המוסכם שאני אומר/ת לעצמי כשזה נדלק?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "דפוס משתנה דרך תנועה קטנה שחוזרת."
    ],
      [
      "סגירה",
      "דפוס משתנה דרך תנועה קטנה שחוזרת."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת “חוזה פנימי” של שורה אחת: “כש__, אני עושה __.”",
      "אני כותב/ת “חוזה פנימי” של שורה אחת: “כש__, אני עושה __.”"
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה: לבחור בי בתוך קשר",
    opening: localizedGenderNode(
      [
      "היום אני לא רוצה/ת להיות מושלם/ת. אני נאמן/ה לעצמי."
    ],
      [
      "היום אני לא רוצה/ת להיות מושלם/ת. אני נאמן/ה לעצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת עמוקה. “אני בוחר/ת חיבור בלי לאבד את עצמי.”",
      "מיינדפולנס קצר:",
      "אני שם לב: מה הדבר הכי חשוב לי לשמור עליו — כבוד עצמי."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת עמוקה. “אני בוחר/ת חיבור בלי לאבד את עצמי.”",
      "מיינדפולנס קצר:",
      "אני שם לב: מה הדבר הכי חשוב לי לשמור עליו — כבוד עצמי."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי עליי במסע הזה?\n[כאן אני כותב]",
      "מה ברור לי עכשיו על הדפוס שלנו?\n[כאן אני כותב]",
      "משפט חזרה לימים קשים (קצר, ברור):\n[כאן אני כותב]"
    ],
      [
      "מה למדתי עליי במסע הזה?\n[כאן אני כותב]",
      "מה ברור לי עכשיו על הדפוס שלנו?\n[כאן אני כותב]",
      "משפט חזרה לימים קשים (קצר, ברור):\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא רק “רודף” ולא רק “בורח”.",
      "אני אדם שמחפש ביטחון ואהבה.",
      "והיום אני לומד/ת לעצור, לנשום, ולבחור תגובה.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא רק “רודף” ולא רק “בורח”.",
      "אני אדם שמחפש ביטחון ואהבה.",
      "והיום אני לומד/ת לעצור, לנשום, ולבחור תגובה.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת פעולה אחת שמסמלת שינוי: הודעה נקייה / פסק זמן נכון / בקשה קצרה.",
      "אני בוחר/ת פעולה אחת שמסמלת שינוי: הודעה נקייה / פסק זמן נכון / בקשה קצרה."
    ),
  },
].map(buildNormalizedDay);

export const pursuerDistancerCycleBlueprintHe = buildNormalizedPilotBlueprint({
  id: "pursuer_distancer_cycle_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "pursuer_distancer_cycle",
  category: "general",
  journeyName: {
    he: "מעגל רודף–נמנע",
    en: "Pursuer–Distancer Cycle",
    es: "Ciclo Perseguidor–Evitador",
  },
  days,
});

export default pursuerDistancerCycleBlueprintHe;
